import { createSlice } from '@reduxjs/toolkit';

type DealerContextType = {
  dealerId: string | undefined;
};

const initialState: DealerContextType = {
  dealerId: undefined,
};

const dealerContextSlice = createSlice({
  name: 'dealerContext',
  initialState,
  reducers: {
    setDealerContext: (_state, action) => {
      return action.payload;
    },
  },
});

export const selectDealerContextId = (state: any): DealerContextType => state.dealerContext;
export const { setDealerContext } = dealerContextSlice.actions;
export default dealerContextSlice.reducer;
